var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup-animations"},[(_vm.animation === 'confetti')?_c('confetti-animation'):_vm._e(),(_vm.animation === 'moon-sun')?_c('moon-sun',{attrs:{"element":_vm.element}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }